export const CLOSE_MAP = '[map] close map'
export const closeMap = () => ({ type: CLOSE_MAP })
